import { connect } from "react-redux";
import injectIntl from "../../../common/helpers/injectIntl";

import { seo } from "../../../common/helpers/seo";

import { changeSort, getResults, setSearch, setPage, setFilters, clearFilters } from "../../store/browse/actions";
import { IStateTree } from "../../store/interfaces";
import { IUser } from "../../store/user/models";

import lazyComponent from "./lazy";

const mapStateToProps = ({ browse, user }: IStateTree) => ({
    browse,
    user: user as IUser,
});

const mapDispatchToProps = { getResults, changeSort, setSearch, setPage, setFilters, clearFilters };

export default {
    component: injectIntl(connect(mapStateToProps, mapDispatchToProps)(lazyComponent)),
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        return seo({
            title: allMessage["menu.browse"],
            description: allMessage["browse.seo.description"],
            allMessage,
            lang,
        });
    },
};
